import { useEffect, useState } from "react";
import { api } from "../lib/api";

const cache = {};

export function useDbBlogPosts(lang = "en") {
    const [posts, setPosts] = useState(cache[lang] || []);
    useEffect(() => {
        if (cache[lang]) { setPosts(cache[lang]); return; }
        setPosts([]);
        let alive = true;
        api.get("/blog/posts", { params: { lang } })
            .then(({ data }) => { cache[lang] = data; if (alive) setPosts(data); })
            .catch(() => {});
        return () => { alive = false; };
    }, [lang]);
    return posts;
}

export function useDbBlogPost(slug, skip, lang = "en") {
    const [state, setState] = useState({ post: null, loading: !skip });
    useEffect(() => {
        if (skip || !slug) { setState({ post: null, loading: false }); return; }
        let alive = true;
        setState({ post: null, loading: true });
        api.get(`/blog/posts/${slug}`, { params: { lang } })
            .then(({ data }) => alive && setState({ post: data, loading: false }))
            .catch(() => alive && setState({ post: null, loading: false }));
        return () => { alive = false; };
    }, [slug, skip, lang]);
    return state;
}
